import React from 'react'
import './Intro.css'

export default function Intro() {
    return (
            <div className='Intro-container'>
                <div className='Intro-inner'>
            <p className='i1'>Hello, I am </p>
            <h1 className='i1'>Alex Yu.</h1>
            <h1 className='i1'>I like to develop things.</h1>
            <p className='i2'>I'm a software engineer who is always eager to learn.
            <br></br>Currently, I'm building out some ML models to apply to sports</p>
            </div>
            </div>

    )
}

/*
navbar-#031f4b
background-#035b96
Text - #b3cde0
#b3cde0d0
headings - #6497b1

heading-#b2e4eb
*/
